import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link as RouterLink, useLocation, Navigate } from 'react-router-dom';

function MobileThanks() {
  const location = useLocation();
  const trackingToken = location.state?.trackingToken;

  if (!trackingToken) {
    return <Navigate to="/m" replace />;
  }

  const statusPath = `/m/hakemus/${encodeURIComponent(trackingToken)}`;

  return (
    <>
      <Helmet>
        <title>Hakemus lähetetty | Rahoituskanava</title>
      </Helmet>
      <Box sx={{ px: 2, py: 3, flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Typography variant="h1" gutterBottom>
            Hakemus lähetetty
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1.5 }}>
            Mitä tapahtuu seuraavaksi
          </Typography>
          <Box
            component="ol"
            sx={{
              pl: 2.25,
              mb: 2,
              color: 'text.primary',
              '& li': { mb: 0.75, pl: 0.5 },
            }}
          >
            <Typography component="li" variant="body1">
              Vahvistamme hakemuksesi tiedot
            </Typography>
            <Typography component="li" variant="body1">
              Haemme tarjouksia useilta rahoittajilta
            </Typography>
            <Typography component="li" variant="body1">
              Olemme sinuun yhteydessä
            </Typography>
          </Box>
          <Typography variant="body1" paragraph>
            Kiitos luottamuksesta — hoidamme kilpailutuksen puolestasi.
          </Typography>
          <Box
            sx={{
              my: 3,
              p: 2,
              bgcolor: 'mobile.highlight',
              borderRadius: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Hakemustunnus
            </Typography>
            <Typography variant="h2" sx={{ fontSize: '1.35rem', letterSpacing: 0.5 }}>
              {trackingToken}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Säilytä hakemustunnus viestintää varten.
            </Typography>
          </Box>
          <Button
            component={RouterLink}
            to={statusPath}
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ mb: 1.5, minHeight: 48 }}
          >
            Seuraa hakemuksen tilaa
          </Button>
          <Button component={RouterLink} to="/m" variant="contained" color="primary" fullWidth>
            Palaa etusivulle
          </Button>
        </Paper>
      </Box>
    </>
  );
}

export function MobileThanksLoan() {
  return <MobileThanks />;
}

export function MobileThanksFactoring() {
  return <MobileThanks />;
}
